module.exports = __webpack_public_path__ + "img/wallet-connect.9bfa4c02.svg";